import Layout from 'HorizontalMenu/Menu';
import Navbar from 'HorizontalMenu/Navbar';
import React from 'react';
import { Col, Container, Label, Row } from 'reactstrap';
import '../global/GlobalCSS.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'index';
import { setVesselID } from 'Store/Generic/ReportingSlice';
import EuMrvEtsPartial from './partials/EuMrvEtsPartial';
import Select from 'react-select';

const EuMrvEts = () => {
    const dispatch = useDispatch();
    const { Vessels, VesselID } = useSelector((state: RootState) => state.Reporting);

    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e.id));
    }

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <Container fluid>
                <Row>
                    <Col lg={4}>
                        <Label className='mb-0'>Select vessel</Label>
                        <Select
                            options={Vessels.filter((item: any) => item.display === true)}
                            getOptionLabel={(option: any) => option.vessel_name}
                            getOptionValue={(option: any) => option.id}
                            onChange={(e: any) => handleVesselSelectionChanges(e)}
                        />
                    </Col>
                </Row>
                {VesselID > 0 &&
                    <EuMrvEtsPartial vesselId={VesselID} />
                }
            </Container>
        </React.Fragment>
    )
}

export default EuMrvEts;